import React from 'react';
import { DropTarget } from 'react-dnd';
import { dropTargetFactory, dropCollect } from './breadcrumbDragDrop';
import { BreadcrumbSpan } from './BreadcrumbLink';

const BreadcrumbRoot = ({ connectDropTarget, isOver, onClick, separator }) => {
  return connectDropTarget(
    <span>
      <BreadcrumbSpan {...{ isOver, onClick }}>Dashboard</BreadcrumbSpan>
      &nbsp;{separator}&nbsp;
    </span>,
  );
};

const rootLinkTarget = dropTargetFactory((objectIdsToMove, { onDrop }) => {
  onDrop(objectIdsToMove);
});

const DroppableRootLink = DropTarget(
  'FSObject',
  rootLinkTarget,
  dropCollect,
)(BreadcrumbRoot);

export default DroppableRootLink;
